import { render, staticRenderFns } from "./Comments.vue?vue&type=template&id=cdede44a&scoped=true&"
import script from "./Comments.vue?vue&type=script&lang=js&"
export * from "./Comments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdede44a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cdede44a')) {
      api.createRecord('cdede44a', component.options)
    } else {
      api.reload('cdede44a', component.options)
    }
    module.hot.accept("./Comments.vue?vue&type=template&id=cdede44a&scoped=true&", function () {
      api.rerender('cdede44a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Admin/CFDI/Comments.vue"
export default component.exports